import React, { Component } from "react";
import {
  Navbar,
  Progress,
  Nav,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardLink,
  CardTitle,
  CardSubtitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";

class LoadingStatusModal extends Component {
  render() {
    const {
      modal,
      toggle,
      countText,
      currentpageLoaded,
      nrOfResultPages
    } = this.props;
    return (
      <Modal
        isOpen={modal}
        toggle={toggle} /*className={this.props.className}*/
      >
        <ModalHeader toggle={toggle}>MORE RESULTS LOADING...</ModalHeader>
        <ModalBody>
          The Adzuna API Only allows us to load 50 results at a time. Your
          search have returned <b>{countText}</b> results.
          <br /> We are loading page nr: {currentpageLoaded} of{" "}
          {nrOfResultPages}
          <br />
          <div className="text-center">
            {Math.floor((currentpageLoaded / nrOfResultPages) * 100)}%
          </div>
          <Progress
            value={Math.floor((currentpageLoaded / nrOfResultPages) * 100)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            OK Thanks!
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default LoadingStatusModal;
